/** PURE_IMPORTS_START .._.._Observable,.._.._operator_materialize PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { materialize } from '../../operator/materialize';
Observable.prototype.materialize = materialize;
//# sourceMappingURL=materialize.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/materialize.js
// module id = 683
// module chunks = 0